// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_ghV","cls2":"SearchOnboardingOverhaul-cls2_186 SearchOnboardingOverhaul-cls1_ghV"};